var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMenuCapsuleHotelsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16797 21.2252V8.89844H12.2497V21.2252H9.16797Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3984 21.2252V8.89844H21.4801V21.2252H18.3984Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.936 16.6032H10.707V13.5215H19.936V16.6032Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3262 28.0625C22.5059 28.0625 28.3262 22.2422 28.3262 15.0625C28.3262 7.8828 22.5059 2.0625 15.3262 2.0625C8.14647 2.0625 2.32617 7.8828 2.32617 15.0625C2.32617 22.2422 8.14647 28.0625 15.3262 28.0625ZM15.3262 30.0625C23.6104 30.0625 30.3262 23.3468 30.3262 15.0625C30.3262 6.77823 23.6104 0.0625 15.3262 0.0625C7.0419 0.0625 0.326172 6.77823 0.326172 15.0625C0.326172 23.3468 7.0419 30.0625 15.3262 30.0625Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMenuCapsuleHotelsWhite);
export default __webpack_public_path__ + "static/media/new-menu-capsule-hotels-white.d99e71f5187173e0aca78c4d3c9f95f0.svg";
export { ForwardRef as ReactComponent };